export default {
      id: "new-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#new",
      toString: function () {
        return this.url;
      }
    }